import { EuiButton, EuiFlexGroup, EuiFlexItem, EuiLoadingSpinner, EuiPanel } from "@elastic/eui";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FilaAjusteDobleDestino } from "../filaAjusteDobleDestino";
import ModalYesNo from "../../../../../components/Modals/YesNo";
import useModal from "../../../../../components/Modals";


export const AjusteDobleDestinoScreen = (props:any)=>{

    const {isOpen,toggle} = useModal();
    const {data, selected, handleSave, handleDelete, isLoading, savePermission} = props;
    
    const [nuevosAjustes,setNuevosAjustes] = useState<any>({});

    const ajustesSalario = useMemo(()=> (data && data.ajustes.filter((a:any)=> a.nombre==='Salario')[0]) || 0,[data])
    const ajustesPrima = useMemo(()=> (data && data.ajustes.filter((a:any)=> a.nombre==='Prima')[0]) || 0,[data])
    const ajustesFiniquito = useMemo(()=> (data && data.ajustes.filter((a:any)=> a.nombre==='Finiquito')[0]) || 0,[data])
    const ajustesIndemnizacion = useMemo(()=> (data && data.ajustes.filter((a:any)=> a.nombre==='Indemnizacion')[0]) || 0,[data])
    const ajustesIrpf = useMemo(()=> (data && data.ajustes.filter((a:any)=> a.nombre==='Irpf')[0]) || 0,[data])
    const ajustesHipotetica = useMemo(()=> (data && data.ajustes.filter((a:any)=> a.nombre==='Hipotetica')[0]) || 0,[data])
    const ajustesSS = useMemo(()=> (data && data.ajustes.filter((a:any)=> a.nombre==='Costo_SS')[0]) || 0,[data])
    const ajustesSSEmpleado = useMemo(()=> (data && data.ajustes.filter((a:any)=> a.nombre==='SS_Empleado')[0]) || 0,[data])

    const empresas = useMemo(()=> data && data.empresas,[data]);

    //saber si es una modificacion o una creacion
    const esUpdate = useMemo(()=>data && data.esAjuste,[data])

    //Si puede ser modificado el ajuste
    const esAjustable = useMemo(()=>selected && selected.ajustable,[selected])

    useEffect(()=>{
        if(data!==undefined)
        {

            const _nuevosAjustes = [{
                Empresa:empresas[0].empresa,
                Salario_Ajuste:ajustesSalario.costoPrimeraEmpresa,
                Prima_Ajuste:ajustesPrima.costoPrimeraEmpresa,
                Finiquito_Ajuste:ajustesFiniquito.costoPrimeraEmpresa,
                Indemnizacion_Ajuste:ajustesIndemnizacion.costoPrimeraEmpresa,
                Irpf_Ajuste:ajustesIrpf.costoPrimeraEmpresa,
                Hipotetica_Ajuste:ajustesHipotetica.costoPrimeraEmpresa,
                SS_Empleado_Ajuste:ajustesSSEmpleado.costoFacturable,
                Costo_SS_Ajuste:ajustesSS.costoPrimeraEmpresa,
                },
                {
                Empresa:empresas[1].empresa,
                Salario_Ajuste:ajustesSalario.costoSegundaEmpresa,
                Prima_Ajuste:ajustesPrima.costoSegundaEmpresa,
                Finiquito_Ajuste:ajustesFiniquito.costoSegundaEmpresa,
                Indemnizacion_Ajuste:ajustesIndemnizacion.costoSegundaEmpresa,
                Irpf_Ajuste:ajustesIrpf.costoSegundaEmpresa,
                Hipotetica_Ajuste:ajustesHipotetica.costoSegundaEmpresa,
                SS_Empleado_Ajuste:ajustesSSEmpleado.costoFacturable,
                Costo_SS_Ajuste:ajustesSS.costoSegundaEmpresa,
                }
            ]
            setNuevosAjustes(_nuevosAjustes)
        }
    },[data])

    const onAddAjuste = (nuevoAjuste:any[]) =>{
        const aj1  = {...nuevosAjustes[0],...nuevoAjuste[0]}
        const aj2  = {...nuevosAjustes[1],...nuevoAjuste[1]}
        setNuevosAjustes([...[aj1,aj2]])
    }

    const onSave = ()=>{handleSave(nuevosAjustes)}

    const onDelete = ()=>{handleDelete();}

    //(data && data.ajustes) &&
    const getDetalle = ()=> (
        <EuiFlexGroup direction="column" alignItems="flexStart" justifyContent="flexStart" gutterSize="m">
        <EuiFlexItem grow={false}>
            <FilaAjusteDobleDestino data={ajustesSalario} showLabel addAjuste={onAddAjuste} esUpdate={esUpdate} enabled={esAjustable}/>
        </EuiFlexItem> 

        <EuiFlexItem grow={false}>
            <FilaAjusteDobleDestino data={ajustesPrima} addAjuste={onAddAjuste} esUpdate={esUpdate} enabled={esAjustable}/>
        </EuiFlexItem> 

        <EuiFlexItem grow={false}>
        <FilaAjusteDobleDestino data={ajustesFiniquito} addAjuste={onAddAjuste} esUpdate={esUpdate} enabled={esAjustable}/>
        </EuiFlexItem> 
    
        <EuiFlexItem grow={false}>
            <FilaAjusteDobleDestino data={ajustesIndemnizacion} addAjuste={onAddAjuste} esUpdate={esUpdate} enabled={esAjustable}/>
        </EuiFlexItem> 

        <EuiFlexItem grow={false}>
            <FilaAjusteDobleDestino data={ajustesIrpf} addAjuste={onAddAjuste} esUpdate={esUpdate} enabled={esAjustable}/>
        </EuiFlexItem> 

        <EuiFlexItem grow={false}>
            <FilaAjusteDobleDestino data={ajustesHipotetica} addAjuste={onAddAjuste} esUpdate={esUpdate} enabled={esAjustable}/>
        </EuiFlexItem> 

        <EuiFlexItem grow={false}>
            <FilaAjusteDobleDestino data={ajustesSSEmpleado} addAjuste={onAddAjuste} esUpdate={esUpdate} enabled={esAjustable}/>
        </EuiFlexItem> 

        <EuiFlexItem grow={false}>
            <FilaAjusteDobleDestino data={ajustesSS} addAjuste={onAddAjuste} esUpdate={esUpdate} enabled={esAjustable}/>
        </EuiFlexItem>
    </EuiFlexGroup>
    )

    const btnEliminar = ()=> (esUpdate && esAjustable) ? 
        <EuiFlexItem grow={false}><EuiButton onClick={()=>{toggle()}} fill color="danger">Eliminar</EuiButton></EuiFlexItem> :null

    const btnGuardar = () => (esAjustable && savePermission) ?
    <EuiFlexItem grow={false}><EuiButton onClick={()=>{onSave()}} fill color="secondary">Guardar</EuiButton></EuiFlexItem> : null

    const getEmpresas = useCallback(()=> empresas && empresas.map((e:any,i:number)=> (
        <>
            <EuiFlexItem grow={false}>
                <span className={`ajustes-expatriados-empresa ${i%2!==0?'other':''}`}><strong>{e.nombre}</strong></span>
            </EuiFlexItem>
            {i<empresas.length-1 ?<EuiFlexItem grow={false}>{'/'}</EuiFlexItem>:null}
        </>
    ))
    ,[empresas])

    if(isLoading){
        return <EuiLoadingSpinner size="xl"/>
    }

    return (
        <>
        <EuiFlexGroup direction="column">
            <EuiFlexItem grow={false} style={{borderBottom: '1px solid #d3dae6',padding: '1rem'}}>
                <EuiFlexGroup justifyContent='spaceBetween' alignItems="center">
                    <EuiFlexItem grow={false}>
                        <EuiFlexGroup alignItems="center">
                            <EuiFlexItem grow={false}>
                                <p style={{fontSize:'smaller'}}><strong>{'DETALLE AJUSTE DOBLE DESTINO'}</strong></p>
                            </EuiFlexItem>
                            <EuiFlexItem grow={false}>
                                <span className="ajustes-expatriados-empleado"><strong>{selected.nombre}</strong></span>
                            </EuiFlexItem>
                            <EuiFlexItem grow={false}>
                                <EuiPanel paddingSize="s">
                                    <EuiFlexGroup>
                                        {getEmpresas()}
                                    </EuiFlexGroup>
                                </EuiPanel>
                            </EuiFlexItem>
                        </EuiFlexGroup>
                    </EuiFlexItem>
                    <EuiFlexItem>
                        <EuiFlexGroup justifyContent="flexEnd">
                            {btnEliminar()}
                            {btnGuardar()}
                        </EuiFlexGroup>
                    </EuiFlexItem>
                </EuiFlexGroup>
            </EuiFlexItem>
            <EuiFlexItem>{getDetalle()}</EuiFlexItem>
        </EuiFlexGroup>
        <ModalYesNo isOpen={isOpen} toggle={toggle} answer={'¿Eliminar el ajuste actual?'} handleConfirm={onDelete}/>
        </>
    );
}